/*!
 * SAPUI5
 * Copyright (c) 2025 SAP SE or an SAP affiliate company. All rights reserved.
 */
import Control from "sap/ui/core/Control";
import { $SearchLinkSettings } from "../../controls/SearchLink";

export type AssemblerConstructor<T> = new () => Assembler<T>;

export interface Assembler<T> {
    addText(text: string);
    addImage(src: string, styleClass?: string);
    addIcon(src: string);
    addLink(props: $SearchLinkSettings);
    addControl(control: Control);

    getResult(): T;
}
